import React, {useContext} from 'react'
import { Layout, Row, Col } from "antd";
import { NavView } from '../../components/NavView';
import { AppContext, useApiContext } from '../../util/context';
import { MenuTab } from '../../components/MenuTab';
import './NewCard.css';
import { NewHazardView } from '../../components/NewHazard/NewHazardView';
import ErrorBoundary from '../../util/ErrorBoundary';

const { Content } = Layout;

export const NewCard = ({appProps}) => {
    const {
        StyledDiv
    } = useContext(AppContext)
    const { client } = useApiContext();
    return (
        <Layout className="layout">
            <Content style={{ padding: "0", backgroundColor: "white" }}>
                <NavView landing = {false} selection="newcard" appProps={appProps}/>

                <Row
                >
                    <Col
                        span={2}
                        className="homeHazardMenu"
                    >
                        <MenuTab location = "newcard" StyledDiv={StyledDiv} appProps={appProps}/>
                    </Col>


                    <Col
                        xl={{span: 22}}
                        lg={{span: 24}}
                        md={{span: 24}}
                        sm={{span: 24}}
                        xs={{span: 24}}
                        style={{
                            height: "91dvh",
                            marginTop: "9dvh",
                        }}
                    >
                        <ErrorBoundary>
                            <NewHazardView client = {client}/>
                        </ErrorBoundary>
                        
                    </Col>
                </Row>
            </Content>
        </Layout>
    )
}
